export { default } from './AutoCompleteSelect';



// WEBPACK FOOTER //
// ./src/design-system/atoms/AutoCompleteSelect/index.jsx